import script from "./CustomerCase.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerCase.vue?vue&type=script&setup=true&lang=js"

import "./CustomerCase.vue?vue&type=style&index=0&id=1ea3d2db&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ea3d2db"]])

export default __exports__